import { render } from "./DataStep.vue?vue&type=template&id=1b0a3cfc&scoped=true"
import script from "./DataStep.vue?vue&type=script&lang=js"
export * from "./DataStep.vue?vue&type=script&lang=js"

import "./DataStep.vue?vue&type=style&index=0&id=1b0a3cfc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b0a3cfc"

export default script